import { useAppContext } from '@/context';
import { logout } from '@/utils/auth';
import { patchJson } from '@/utils/fetchOptions';

// eslint-disable-next-line import/no-cycle
import { useAuthToken, useMutation } from '.';

interface UseTeamMemberUpdateProps {
  onSuccess: TypeAny;
  teamId: string;
  userId: string;
  role: string;
}

export function useTeamMemberUpdate({ onSuccess, teamId, userId, role }: UseTeamMemberUpdateProps) {
  const { setAlert } = useAppContext();
  const token = useAuthToken();

  const {
    mutate: mutation,
    error,
    isLoading
  } = useMutation({
    mutationKey: 'team-member-update',
    mutationFn: async () =>
      patchJson({
        url: `${process.env.NEXT_PUBLIC_BEATLY_API_URL}/app/v2/team/${teamId}/member/${userId}/update`,
        body: { role },
        token
      }).then((response: Api.Member | ResponseObject) => {
        if ((response as ResponseExpiredToken).isExpired) {
          logout();
        }

        if ('code' in response) {
          setAlert(response.code);
        }

        return response;
      }),
    onSuccess
  });

  return {
    isLoading,
    mutation,
    error
  };
}
